import { acceptHMRUpdate, defineStore } from 'pinia';

export interface LocalPayload {
  Filters: any[];
  Ordering: any[];
  Page: number;
  Limit: number;
  IsFilterFavorite?: boolean;
  Segment_Type?: any[];
  Flag_Count?: boolean;
  tableId?: number;
  Status?: number;
  Channel?: number;
  Query?: string;
  Search_Value?: string;
  search?: string;
}

export const useRouterBypassStore = defineStore({
  id: 'router_bypass_confirmation',

  state: (): { bypassConfirmation: boolean } => ({
    bypassConfirmation: false,
  }),
  getters: {
    isBypassConfirmation(state): boolean {
      return state.bypassConfirmation;
    },
  },
  actions: {
    update(isBypass: boolean) {
      this.bypassConfirmation = isBypass;
    },
    reset() {
      this.bypassConfirmation = false;
    },
  },
});

export const useLocalPayloadStore = defineStore('local_payload', {
  state: (): { localPayloadMap: Map<string, LocalPayload> } => ({
    localPayloadMap: new Map<string, LocalPayload>(),
  }),
  actions: {
    setPayloadForPage(pageKey: string, payload: LocalPayload) {
      this.localPayloadMap.set(pageKey, payload);
    },
    getPayloadForPage(pageKey: string): LocalPayload {
      return (
        this.localPayloadMap.get(pageKey) ?? {
          Filters: [],
          Ordering: [],
          Page: 1,
          Limit: 10,
        }
      );
    },
    updateKeyInPage(pageKey: string, value: any, key: 'page' | 'limit' | 'search' | 'status' | 'isFilterFavorite' | 'typeSegment') {
      const payload = this.getPayloadForPage(pageKey);
      if (key === 'page') payload.Page = value;
      else if (key === 'limit') payload.Limit = value;
      else if (key === 'search') payload.search = value;
      else if (key === 'status') payload.Status = value;
      else if (key === 'isFilterFavorite') payload.IsFilterFavorite = value;
      else if (key === 'typeSegment') payload.Segment_Type = value;

      this.localPayloadMap.set(pageKey, payload);
    },

    resetPagePayload(pageKey: string) {
      this.localPayloadMap.set(pageKey, {
        Filters: [],
        Ordering: [],
        Page: 1,
        Limit: 10,
      });
    },
  },
  // persist: {
  //   key: 'local_payload',
  //   storage: localStorage,
  // },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useRouterBypassStore, import.meta.hot));
  import.meta.hot.accept(acceptHMRUpdate(useLocalPayloadStore, import.meta.hot));
}
